import { motion, useInView } from "framer-motion";
import { useRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactSection() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [status, setStatus] = useState("idle");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) return;
    setStatus("loading");
    try {
      await axios.post(`${API}/contact`, form);
      setStatus("success");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch {
      setStatus("error");
    }
  };

  return (
    <section id="contact" data-testid="contact-section" ref={ref} className="py-24 md:py-32 lg:py-40 bg-[#FAF7F3]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="md:col-span-5"
          >
            <div className="flex items-center gap-4 mb-6">
              <div className="w-8 h-[2px] bg-[#c13a05]" />
              <span className="font-sub text-[#c13a05] text-[11px] tracking-[0.25em] font-bold">
                İLETİŞİM
              </span>
            </div>

            <h2 className="font-heading text-4xl sm:text-5xl font-normal text-[#1A1A1A] tracking-tight leading-tight mb-8">
              Bilgi<br />
              <span className="italic text-[#c13a05]">Talebinde Bulunun</span>
            </h2>

            <p className="font-body text-[#5A5A58] text-base leading-relaxed font-light mb-10">
              FINORA hakkında detaylı bilgi almak ve yatırım fırsatlarını
              değerlendirmek için formu doldurun. En kısa sürede sizinle iletişime geçelim.
            </p>

            <img src="/images/logos/logo-siyah.svg" alt="FINORA" className="h-7 mb-8 opacity-60" />

            <div className="space-y-4">
              <div>
                <p className="font-sub text-[10px] text-[#c13a05] tracking-[0.15em] font-bold mb-1">PROJE SAHİBİ</p>
                <p className="font-heading text-lg text-[#1A1A1A]">Sirius Port</p>
              </div>
              <div>
                <p className="font-sub text-[10px] text-[#c13a05] tracking-[0.15em] font-bold mb-1">PAZARLAMA</p>
                <p className="font-heading text-lg text-[#1A1A1A]">Riba Gayrimenkul</p>
              </div>
              <div>
                <p className="font-sub text-[10px] text-[#c13a05] tracking-[0.15em] font-bold mb-1">İNŞAAT</p>
                <p className="font-heading text-lg text-[#1A1A1A]">Pınarlar Grup</p>
              </div>
              <div>
                <p className="font-sub text-[10px] text-[#c13a05] tracking-[0.15em] font-bold mb-1">TELEFON</p>
                <p className="font-sub text-lg text-[#1A1A1A] font-bold tracking-wide">444 4 919</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="md:col-span-7 lg:col-span-6 lg:col-start-7"
          >
            {status === "success" ? (
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                className="bg-[#F0EBE3] p-12 text-center h-full flex flex-col items-center justify-center"
              >
                <img src="/images/brandmarks/brandmark-turuncu.svg" alt="" className="w-12 mb-6 opacity-60" />
                <p className="font-heading text-2xl text-[#1A1A1A] mb-3">Teşekkür Ederiz</p>
                <p className="font-body text-[#5A5A58] text-sm font-light">
                  Bilgileriniz bize ulaştı. En kısa sürede sizinle iletişime geçeceğiz.
                </p>
                <button
                  data-testid="send-another-btn"
                  onClick={() => setStatus("idle")}
                  className="mt-8 font-sub text-[11px] tracking-[0.15em] font-bold text-[#c13a05] border-b-2 border-[#c13a05] pb-0.5 hover:text-[#a83004] transition-colors"
                >
                  YENİ FORM GÖNDER
                </button>
              </motion.div>
            ) : (
              <form onSubmit={handleSubmit} className="bg-[#F0EBE3] p-8 md:p-12" data-testid="contact-form">
                <div className="space-y-8">
                  <div>
                    <Label className="font-sub text-[10px] tracking-[0.15em] text-[#5A5A58] font-bold mb-3 block">
                      AD SOYAD *
                    </Label>
                    <Input
                      data-testid="contact-name-input"
                      value={form.name}
                      onChange={(e) => setForm({ ...form, name: e.target.value })}
                      className="finora-input bg-transparent border-0 border-b border-[#D8D2C6] rounded-none px-0 focus-visible:ring-0 focus-visible:border-[#c13a05] text-[#1A1A1A] font-body"
                      placeholder="Adınızı giriniz"
                      required
                    />
                  </div>

                  <div>
                    <Label className="font-sub text-[10px] tracking-[0.15em] text-[#5A5A58] font-bold mb-3 block">
                      E-POSTA *
                    </Label>
                    <Input
                      data-testid="contact-email-input"
                      type="email"
                      value={form.email}
                      onChange={(e) => setForm({ ...form, email: e.target.value })}
                      className="finora-input bg-transparent border-0 border-b border-[#D8D2C6] rounded-none px-0 focus-visible:ring-0 focus-visible:border-[#c13a05] text-[#1A1A1A] font-body"
                      placeholder="E-posta adresiniz"
                      required
                    />
                  </div>

                  <div>
                    <Label className="font-sub text-[10px] tracking-[0.15em] text-[#5A5A58] font-bold mb-3 block">
                      TELEFON
                    </Label>
                    <Input
                      data-testid="contact-phone-input"
                      type="tel"
                      value={form.phone}
                      onChange={(e) => setForm({ ...form, phone: e.target.value })}
                      className="finora-input bg-transparent border-0 border-b border-[#D8D2C6] rounded-none px-0 focus-visible:ring-0 focus-visible:border-[#c13a05] text-[#1A1A1A] font-body"
                      placeholder="Telefon numaranız"
                    />
                  </div>

                  <div>
                    <Label className="font-sub text-[10px] tracking-[0.15em] text-[#5A5A58] font-bold mb-3 block">
                      MESAJ
                    </Label>
                    <textarea
                      data-testid="contact-message-input"
                      value={form.message}
                      onChange={(e) => setForm({ ...form, message: e.target.value })}
                      className="finora-input w-full bg-transparent border-0 border-b border-[#D8D2C6] rounded-none px-0 focus-visible:ring-0 focus-visible:outline-none resize-none h-24 text-[#1A1A1A] font-body text-[15px]"
                      placeholder="Mesajınız (isteğe bağlı)"
                      style={{ borderBottom: '1px solid #D8D2C6' }}
                    />
                  </div>

                  {status === "error" && (
                    <p data-testid="form-error" className="font-body text-sm text-red-600">
                      Bir hata oluştu. Lütfen tekrar deneyin.
                    </p>
                  )}

                  <Button
                    data-testid="contact-submit-btn"
                    type="submit"
                    disabled={status === "loading"}
                    className="w-full bg-[#c13a05] hover:bg-[#a83004] text-white font-sub text-[11px] tracking-[0.2em] font-bold py-6 rounded-none transition-all duration-300"
                  >
                    {status === "loading" ? "GÖNDERİLİYOR..." : "BİLGİ TALEP ET"}
                  </Button>
                </div>
              </form>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
